
import { join, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { NotificationChannelModeModule_all, CustomerNotificationSetting, NotificationChannelModule_all, NotificationChannel, NotificationChannelMode, NotificationMessageModule_byArea, NotificationChannelModeModule_key, NotificationAreaModule_key, NotificationChannelModule_key, NotificationMessageModule_key } from "../Shared/NotificationSettings.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { iterate, empty, map, collect, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { empty as empty_1, tryFind, forAll, isEmpty, filter, map as map_1, length, cons, ofArray, singleton as singleton_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { curry2, equals, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Checkbox } from "../Components/Checkbox.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Select } from "../Components/Select.js";
import { defaultArg, unwrap, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";

function messageLabel(t, message) {
    return t(concat("notification_settings.message.", ...NotificationMessageModule_key(message)));
}

function channelLabel(t, channel) {
    return t(concat("notification_settings.channel.", ...NotificationChannelModule_key(channel)));
}

function areaLabel(t, area) {
    return t(concat("notification_settings.area.", ...NotificationAreaModule_key(area)));
}

function modeLabel(t, mode) {
    return t(concat("notification_settings.mode.", ...NotificationChannelModeModule_key(mode)));
}

function headerCellWith(alignCenter, children) {
    return reactElement("th", {
        className: join(" ", toList(delay(() => append(singleton("px-2"), delay(() => append(singleton("py-2"), delay(() => append(singleton("text-sm"), delay(() => append(singleton("font-bold"), delay(() => append(singleton("border-b"), delay(() => append(singleton("border-gray-200"), delay(() => (alignCenter ? singleton("text-center") : singleton("text-left"))))))))))))))))),
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function headerCell(text, alignCenter) {
    return headerCellWith(alignCenter, singleton_1(text));
}

function areaRow(label, columnCount) {
    let elems;
    return reactElement("tr", createObj(singleton_1((elems = [reactElement("td", {
        className: join(" ", ["px-2", "pt-4", "pb-1", "text-sm", "font-bold", "text-black"]),
        colSpan: columnCount,
        children: label,
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

function messageCell(label) {
    return reactElement("td", {
        className: join(" ", ["px-2", "py-1", "text-sm"]),
        children: label,
    });
}

function notAvailableCell(title) {
    return reactElement("td", {
        className: join(" ", ["px-2", "py-1", "text-center", "text-text-muted"]),
        title: title,
        children: "–",
    });
}

function cellCheckbox(testId, isChecked, isDisabled, title, onChange) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center"])], ["title", title], (elems = [Checkbox({
        ComponentState: isDisabled ? "disabled" : "enabled",
        IsChecked: isChecked,
        Label: "",
        OnCheck: onChange,
        TestId: testId,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function matrix(t, rowClasses, channelColumns, rows) {
    let elems_3, children, elems, elems_2;
    return reactElement("table", createObj(ofArray([["data-test-id", "notification-settings-matrix"], ["className", join(" ", ["w-full", "border-collapse"])], (elems_3 = [(children = singleton_1(reactElement("tr", createObj(singleton_1((elems = cons(headerCell(t("notification_settings.message_column"), false), channelColumns), ["children", reactApi.Children.toArray(Array.from(elems))]))))), reactElement("thead", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), reactElement("tbody", createObj(singleton_1((elems_2 = toList(delay(() => collect((matchValue) => append(singleton(areaRow(areaLabel(t, matchValue[0]), length(channelColumns) + 1)), delay(() => map((message) => {
        let elems_1;
        return reactElement("tr", createObj(ofArray([["data-test-id", concat("notification-row-", ...NotificationMessageModule_key(message))], ["className", join(" ", rowClasses)], (elems_1 = cons(messageCell(messageLabel(t, message)), rows(message)), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }, matchValue[1]))), NotificationMessageModule_byArea))), ["children", reactApi.Children.toArray(Array.from(elems_2))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function UserNotificationSettings(props) {
    let elems_2;
    const t = useTranslation()[0];
    const columns = map_1((channel_1) => {
        let elems;
        const changeable = filter((cell_3) => {
            if (equals(cell_3.Channel, channel_1)) {
                const cell_2 = cell_3;
                if (cell_2.Available && equals(cell_2.Mode, new NotificationChannelMode(0, []))) {
                    if (!equals(cell_2.Channel, new NotificationChannel(0, []))) {
                        return true;
                    }
                    else {
                        return props.Settings.MailAllowedByRole;
                    }
                }
                else {
                    return false;
                }
            }
            else {
                return false;
            }
        }, props.Settings.Cells);
        const allEnabled = !isEmpty(changeable) && forAll((_arg) => _arg.Enabled, changeable);
        return headerCellWith(true, singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "items-center", "gap-1"])], (elems = [reactElement("span", {
            children: channelLabel(t, channel_1),
        }), cellCheckbox(concat("notification-select-all-", ...NotificationChannelModule_key(channel_1)), allEnabled, (props.ComponentState === "disabled") ? true : isEmpty(changeable), t("notification_settings.select_all_column"), (_arg_1) => {
            props.OnToggle(map_1((cell_4) => [cell_4.Message, cell_4.Channel], changeable), !allEnabled);
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))));
    }, NotificationChannelModule_all);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-3"])], (elems_2 = toList(delay(() => append(singleton(reactElement("div", {
        className: join(" ", ["text-sm"]),
        children: t("notification_settings.description"),
    })), delay(() => append(!props.Settings.MailAllowedByRole ? singleton(reactElement("div", {
        "data-test-id": "notification-settings-mail-role-hint",
        className: join(" ", ["text-sm", "text-text-muted"]),
        children: t("notification_settings.mail_role_hint"),
    })) : empty(), delay(() => append(singleton(matrix(t, ofArray(["border-b", "border-gray-200"]), columns, (message_1) => map_1((channel_2) => {
        let elems_1;
        const testId = concat("notification-setting-", NotificationMessageModule_key(message_1), "-", ...NotificationChannelModule_key(channel_2));
        const matchValue = tryFind((cell) => {
            if (equals(cell.Message, message_1)) {
                return equals(cell.Channel, channel_2);
            }
            else {
                return false;
            }
        }, props.Settings.Cells);
        let matchResult, cell_6;
        if (matchValue != null) {
            if (matchValue.Available) {
                matchResult = 0;
                cell_6 = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const roleBlocksMail = equals(channel_2, new NotificationChannel(0, [])) && !props.Settings.MailAllowedByRole;
                let patternInput_1;
                const matchValue_1 = cell_6.Mode;
                patternInput_1 = ((matchValue_1.tag === 2) ? [true, t("notification_settings.required_hint")] : ((matchValue_1.tag === 0) ? [cell_6.Enabled, roleBlocksMail ? t("notification_settings.mail_role_hint") : ""] : [false, t("notification_settings.locked_hint")]));
                const isDisabled = ((props.ComponentState === "disabled") ? true : !equals(cell_6.Mode, new NotificationChannelMode(0, []))) ? true : roleBlocksMail;
                return reactElement("td", createObj(ofArray([["className", join(" ", ["px-2", "py-1", "text-center"])], ["data-mode", NotificationChannelModeModule_key(cell_6.Mode)], (elems_1 = [cellCheckbox(testId, patternInput_1[0], isDisabled, patternInput_1[1], curry2(props.OnToggle)(singleton_1([message_1, channel_2])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
            }
            default:
                return notAvailableCell(t("notification_settings.not_available"));
        }
    }, NotificationChannelModule_all))), delay(() => singleton(reactElement("div", {
        className: join(" ", ["text-xs", "text-text-muted"]),
        children: t("notification_settings.legend"),
    })))))))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function CustomerNotificationSettings(props) {
    let elems_3;
    const t = useTranslation()[0];
    const isDisabled = props.ComponentState === "disabled";
    const modeOption = (mode) => ({
        label: modeLabel(t, mode),
        value: mode,
    });
    const columns = map_1((channel_1) => headerCell(`${channelLabel(t, channel_1)}: ${t("notification_settings.default_label")} / ${t("notification_settings.mode_label")}`, true), NotificationChannelModule_all);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-3"])], (elems_3 = [reactElement("div", {
        className: join(" ", ["text-sm"]),
        children: t("notification_settings.customer_description"),
    }), matrix(t, empty_1(), columns, (message_1) => map_1((channel_2) => {
        let elems_2, elems_1, elems, Options, Value;
        const key = concat(NotificationMessageModule_key(message_1), "-", ...NotificationChannelModule_key(channel_2));
        const matchValue = tryFind((setting) => {
            if (equals(setting.Message, message_1)) {
                return equals(setting.Channel, channel_2);
            }
            else {
                return false;
            }
        }, props.Settings);
        if (matchValue == null) {
            return notAvailableCell(t("notification_settings.not_available"));
        }
        else {
            const setting_2 = matchValue;
            return reactElement("td", createObj(ofArray([["className", join(" ", ["px-2", "py-1"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center", "gap-2"])], (elems_1 = [cellCheckbox(concat("customer-notification-default-", ...key), setting_2.DefaultEnabled, isDisabled, t("notification_settings.default_label"), (enabled) => {
                props.OnChange(new CustomerNotificationSetting(setting_2.Message, setting_2.Channel, enabled, setting_2.Mode));
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-[190px]", "text-left"])], (elems = [createElement(Select, (Options = map_1(modeOption, NotificationChannelModeModule_all), (Value = modeOption(setting_2.Mode), {
                ComponentState: props.ComponentState,
                IsClearable: false,
                NoOptionsMessage: "general.no_options",
                OnChange: (selected) => {
                    iterate((selected_1) => {
                        props.OnChange(new CustomerNotificationSetting(setting_2.Message, setting_2.Channel, setting_2.DefaultEnabled, selected_1.value));
                    }, toArray(selected));
                },
                Options: Options,
                PlaceholderKey: "notification_settings.mode_label",
                TestId: concat("customer-notification-mode-", ...key),
                Value: unwrap(Value),
            })))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
        }
    }, NotificationChannelModule_all))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function NewsletterConsent(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems = [reactElement("div", {
        className: join(" ", ["font-bold", "mb-1"]),
        children: t("user.newsletter.title"),
    }), Checkbox({
        ComponentState: props.FormState,
        IsChecked: defaultArg(props.User.NewsletterConsent, false),
        Label: t("user.newsletter.consent_label"),
        OnCheck: (_arg) => {
            props.OnChangeNewsletterConsent(!defaultArg(props.User.NewsletterConsent, false));
        },
        TestId: "newsletter-consent",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

